<template>
  <DataListStateful
    title="Сотрудники"
    resource="employees"
    store="employees"
    :columns="columns"
    :filter-options="filter"
  />
</template>

<script>
export default {
  data() {
    return {
      columns: [
        { title: "Ид", name: "id", sortable: true },
        { title: "Наименование", name: "fullName", sortable: true },
        {
          title: "Телефон",
          name: "phones",
          type: "text-array-phone",
          sortable: true,
        },
        { title: "Email", name: "email", sortable: true },
        {
          title: "Должность",
          name: "positionsText",
        },
        { title: "Офис", name: "office", dataPath: "Office.Title" },
        { title: "Направления", name: "directionText" },
      ],
      filter: {
        title: {
          title: "Наименование",
          type: "text",
        },
        phone: {
          title: "Телефон",
          type: "text",
        },
        email: {
          title: "Email",
          type: "text",
        },
        position: {
          title: "Должность",
          type: "multiple-reference",
          resource: "positions",
        },
        office: {
          title: "Офис",
          type: "reference",
          resource: "offices",
        },
        direction: {
          title: "Направление",
          type: "reference",
          resource: "countries",
        },
      },
    };
  },
};
</script>
